import React, { useEffect } from 'react';
import { QueryProvider, params, shape, string as stringType } from '@thd-nucleus/data-sources';
import classNames from 'classnames/bind';

import { HomeServicePhpCarousel } from './carousel/HomeServicePhpCarousel';
import styles from './personalized-home-services.module.scss';

const PersonalizedHomeServices = () => {
  useEffect(() => {
    LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('personalized-home-services.ready');
  }, []);
  const cx = classNames.bind(styles);

  return (
    <section className={cx('personalized-home-page')}>
      <div className={cx('personalized-home-page__carousel-pod')}>
        <QueryProvider cacheKey="php-home-services">
          <HomeServicePhpCarousel />
        </QueryProvider>
      </div>
    </section>
  );
};

PersonalizedHomeServices.propTypes = {};

PersonalizedHomeServices.defaultProps = {};

PersonalizedHomeServices.displayName = 'PersonalizedHomeServices';

PersonalizedHomeServices.dataModel = {
  product: params({ itemId: stringType().isRequired() }).shape({
    itemId: stringType(),
    dataSource: stringType(),
    identifiers: shape({
      productLabel: stringType(),
    }),
  }),
};

export { PersonalizedHomeServices };
